export default __webpack_public_path__ + "static/media/X-logo.299c50f5.svg";